import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    company: { operators: url, autoDisabled },
  },
} = config

const getUrl = (operator) =>
  url.replace(':idCompany', operator.idCompany || operator.company).replace(':idDashuser', operator._id ? `?idDashuser=${operator._id}` : '')

/**
 * Add a new operator to the company
 * @param {Object} operator Operator object
 */
const addOperator = (operator) => axios.post(getUrl(operator), { user: operator }, { headers: getHeaders(true) })

const getOperators = (operator) => axios.get(getUrl(operator), { headers: getHeaders(true) })

const updateOperator = (operator) => axios.put(getUrl(operator), { user: operator }, { headers: getHeaders(true) })

const deleteOperator = (operator) => axios.delete(getUrl(operator), { headers: getHeaders(true) })

const activation = (operatorId) => axios.post(config.endpoints.company.activation, { operatorId: operatorId }, { headers: getHeaders(true) })

const updateOperatorAutoDisabled = (operatorDisabled) => axios.post(
  autoDisabled,
  operatorDisabled,
  { headers: getHeaders(true) }
)

export default { addOperator, getOperators, updateOperator, deleteOperator, activation, updateOperatorAutoDisabled }
